import { AnalyticsBrowser, Plugin } from '@segment/analytics-next';
import cookie from 'js-cookie';

/**
 * Custom Segment plugin to add traffic source information based on cookies.
 */
export const traffickTypePlugin: Plugin = {
  name: 'traffickTypePlugin',
  version: '1.0.0',
  type: 'before',
  isLoaded: () => true,
  load: async ctx => {
    return ctx;
  },
  page: ctx => {
    const trafficSource = cookie.get('le_internal_user');
    if (!ctx.event.properties || !trafficSource) {
      return ctx;
    }
    ctx.event.properties.trafficSource = 'internal';

    return ctx;
  },
};

export const analytics = new AnalyticsBrowser();

export const initializeAnalytics = () => {
  const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY;
  if (!writeKey) {
    return;
  }

  analytics.load({
    writeKey,
    plugins: [traffickTypePlugin],
  });
};
